import * as ng from 'angular';

const releaseNotes = require('../../../../CHANGELOG.md');

export class ChangelogController {
   static $inject = ['titleService', 'session', '$sce'];

   isGuest:boolean;
   releaseNotes:string;

   constructor(titleService, session, $sce:ng.ISCEService) {
      titleService.setTitle('Release Notes');
      this.isGuest = !session.isLoggedIn();
      this.releaseNotes = $sce.trustAsHtml(releaseNotes);
   }
}

ng.module('e360')
   .controller('ChangelogController', ChangelogController);
